/** @format */
import { css } from 'styled-components';

export type AsideMenuStyleProps = {
    $isOpen: boolean;
};

const baseStyles = ({ $isOpen }: AsideMenuStyleProps) => css`
    > aside {
        position: relative;
        background-color: var(--colors-surface-primary);
        border: none;
        background-clip: padding-box;
        border: solid var(--layout-spacing-2) transparent;
        border-radius: 1.2rem;
        margin: var(--layout-spacing-2) 0;
        box-shadow: var(--effects-shadow-base);

        &:before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: -1;
            margin: calc(var(--layout-spacing-2) * -1);
            border-radius: inherit;
            background: var(--colors-brand-secondary);
            opacity: 0;
            transition-property: opacity;
            transition-duration: var(--animations-default-duration);
            transition-timing-function: var(
                --animations-default-timing-function
            );
        }

        &:has(.aside-menu__title:hover):before {
            opacity: 1;
        }

        > .aside-menu__title-container {
            .aside-menu__title {
                justify-content: flex-start;
                cursor: pointer;
                display: flex;
                align-items: center;

                svg {
                    transition: 0.3s ease-in-out transform;
                    transform: scaleY(${$isOpen ? -1 : 1});
                }
            }

            .aside-menu__title-extra-content {
                margin-left: auto;
            }

            .toggle-button {
                cursor: pointer;
                margin: 0 var(--layout-spacing-16);
            }
        }

        .aside-menu__content-container {
            display: grid;
            grid-template-rows: ${$isOpen ? '1fr' : '0fr'};
            transition: grid-template-rows var(--animations-duration-slower)
                var(--animations-default-timing-function);
            overflow: hidden;
        }

        .aside-menu__content {
            min-height: 0;
            padding-top: var(--layout-spacing-24);
        }
    }
`;

export const styles = (props: AsideMenuStyleProps) => css`
    ${baseStyles(props)}
`;
